var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "BulkIndexContractServiceFee",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              resourceTitle: _vm._f("pgettext")(
                "Contract Service Fees",
                "BulkIndexContractServiceFee|ResourceTitle"
              ),
              resourceKey: _vm._f("pgettext")(
                "Indexing",
                "BulkIndexContractServiceFee|ResourceKey"
              )
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    id: _vm.formId,
                    name: _vm.formName,
                    autofocus: "first"
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "percentage",
                        label: _vm._f("pgettext")(
                          "Percentage",
                          "BulkIndexContractServiceFee"
                        ),
                        description: _vm._f("pgettext")(
                          "The percentage used to calculate the indexed prices.",
                          "BulkIndexContractServiceFee"
                        ),
                        labelColsMd: "3",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group",
                        appendText: "%",
                        required: ""
                      }
                    },
                    [
                      _c("ItpFormInput", {
                        attrs: {
                          name: "percentage",
                          mask: "number",
                          unmask: "typed",
                          scale: "4",
                          required: ""
                        },
                        model: {
                          value: _vm.item.percentage,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "percentage", $$v)
                          },
                          expression: "item.percentage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "valid_from",
                        label: _vm._f("pgettext")(
                          "Valid From",
                          "BulkIndexContractServiceFee"
                        ),
                        description: _vm._f("pgettext")(
                          "The start date from which the new fee is valid.",
                          "BulkIndexContractServiceFee"
                        ),
                        labelColsMd: "3",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        required: ""
                      }
                    },
                    [
                      _c("ItpFormDatetime", {
                        attrs: { name: "valid_from", required: "" },
                        model: {
                          value: _vm.item.valid_from,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "valid_from", $$v)
                          },
                          expression: "item.valid_from"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "new_indexation_date",
                        label: _vm._f("pgettext")(
                          "New Indexation Date",
                          "BulkIndexContractServiceFee"
                        ),
                        description: _vm._f("pgettext")(
                          "Sets the next indexation date for the related contracts.",
                          "BulkIndexContractServiceFee"
                        ),
                        labelColsMd: "3",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("ItpFormDatetime", {
                        attrs: { name: "new_indexation_date" },
                        model: {
                          value: _vm.item.new_indexation_date,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "new_indexation_date", $$v)
                          },
                          expression: "item.new_indexation_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "transaction_notes",
                        label: _vm._f("pgettext")(
                          "Transaction notes",
                          "ContractServiceFee"
                        ),
                        labelColsMd: "3",
                        contentColsMd: "9",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    [
                      _c("TransactionNotesEditor", {
                        staticClass: "w-auto",
                        attrs: { type: "number", name: "transaction_notes" },
                        model: {
                          value: _vm.item.transaction_notes,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "transaction_notes", $$v)
                          },
                          expression: "item.transaction_notes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Submit", "Button"),
                  disabled:
                    !_vm.forms[_vm.formName] ||
                    !_vm.forms[_vm.formName].submittable,
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: _vm.$config.submitIcon,
                  spinning: _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }